import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

// Mounts the tooltip and form-field React islands into server-emitted
// placeholders on a full-React page.
export const initWidgets = async (lazy = true): Promise<void> => {
    const document = getDocument();
    if (!document) return;

    const loading: Array<Promise<unknown>> = [];

    // Tooltips
    const tooltips = document.querySelectorAll<HTMLElement>("[data-tooltip]");
    if (tooltips) {
        const { initTooltips } = await import("./tooltips");
        initTooltips(lazy);
    }

    // Forms
    const formFields = document.querySelectorAll<HTMLElement>(
        ".form-field-placeholder",
    );
    if (formFields) {
        const { initFormFields } = await import("./initFormFields");
        Array.from(formFields).forEach((formField) => {
            loading.push(initFormFields(formField));
        });
    }

    // Wait for everything to finish loading
    await Promise.all(loading);
};
